namespace TabAurous.OMS {
    export interface AttributeMasterForm {
        AttributeId: Serenity.IntegerEditor;
        AttributeTypeId: Serenity.LookupEditor;
        AttributeCode: Serenity.StringEditor;
        AttributeName: Serenity.StringEditor;
        Num1: Serenity.LookupEditor;
        StdPurity: Serenity.DecimalEditor;
        MinPurity: Serenity.DecimalEditor;
        MaxPurity: Serenity.DecimalEditor;
        SPGravity: Serenity.DecimalEditor;
        PurchaseFormula: Serenity.DecimalEditor;
        SalesFormula: Serenity.DecimalEditor;
        GroupSieveId: Serenity.LookupEditor;
        IsParent: Serenity.BooleanEditor;
    }

    export class AttributeMasterForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.AttributeMaster';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!AttributeMasterForm.init)  {
                AttributeMasterForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.LookupEditor;
                var w2 = s.StringEditor;
                var w3 = s.DecimalEditor;
                var w4 = s.BooleanEditor;

                Q.initFormType(AttributeMasterForm, [
                    'AttributeId', w0,
                    'AttributeTypeId', w1,
                    'AttributeCode', w2,
                    'AttributeName', w2,
                    'Num1', w1,
                    'StdPurity', w3,
                    'MinPurity', w3,
                    'MaxPurity', w3,
                    'SPGravity', w3,
                    'PurchaseFormula', w3,
                    'SalesFormula', w3,
                    'GroupSieveId', w1,
                    'IsParent', w4
                ]);
            }
        }
    }
}
